import React from "react";
import { Link } from "react-router-dom";
import withContentFallback from "../../utils/withContentFallback";
import { contactPreviewContent } from "../../constants/homePageContent";
import "./ContactPreview.css";

const ContactPreview = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const {
    heading,
    text,
    buttonText,
    buttonLink,
    phoneNumber,
    phoneButtonText,
  } = content;

  return (
    <section className="contact-preview section animate-on-scroll">
      <div className="container">
        <div className="contact-preview-content">
          <h2>{heading}</h2>
          <p>{text}</p>
          <div className="contact-preview-buttons">
            <Link to={buttonLink} className="btn btn-primary">
              {buttonText}
            </Link>
            <a
              href={`tel:${phoneNumber}`}
              className="btn btn-outline"
              aria-label="Call our phone number"
            >
              {phoneButtonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(ContactPreview, contactPreviewContent);
